import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { EMPLOYEE_PAY_IN_OUT_CATEGORY } from "../../utils/Utils";

import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const EMPLOYEE_PAY_IN_OUT_CATEGORY_OPTIONS = Object.keys(EMPLOYEE_PAY_IN_OUT_CATEGORY).map((c) => ({
  label: EMPLOYEE_PAY_IN_OUT_CATEGORY[c],
  value: c,
}));

const DEFAULT_EMPLOYEE_PAY_IN_OUT = {
  id: "",
  date: moment().format("YYYY-MM-DD"),
  userId: "",
  userIds: [],
  amount: 0,
  category: '',
  description: '',
};

const PayInOutManager = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch
  } = useForm({
    defaultValues: DEFAULT_EMPLOYEE_PAY_IN_OUT,
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [filter, setFilter] = useState({
    userId: searchParams.get('userId') || undefined,
    category: searchParams.get('category') || undefined,
  });

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf('days').toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "Nhân viên",
      accessor: (item) => item?.user?.name || "",
    },
    {
      Header: "Loại",
      accessor: (item) => EMPLOYEE_PAY_IN_OUT_CATEGORY[item.category] || "",
    },
    {
      Header: "Tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.amount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Nội dung",
      accessor: (item) => item.description,
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("user", {
    }, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.userId ? { userId: filter.userId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.userId ? { userId: filter.userId } : {}),
      ...(filter.category ? { category: filter.category } : {}),
    };

    GET(`employee/pay-in-out`, params, true)
      .then(({ data }) => {
        setData([...data]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`employee/pay-in-out/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      date,
      userId,
      userIds,
      category,
      amount,
      description
    } = getValues();

    const formData = {
      date,
      userId,
      userIds,
      category,
      amount,
      description
    };

    const request = editId
      ? PUT(`employee/pay-in-out/${editId}`, formData, {}, true)
      : POST("employee/bulk-create-pay-in-out", formData, {}, true);

    request
      .then(() => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false });
    reset({
      ...DEFAULT_EMPLOYEE_PAY_IN_OUT
    });
    setEditedId(null);
    setDeleteId(null);
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`employee/pay-in-out/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };
  return (
    <React.Fragment>
      <Head title="Quản lý Tiền thưởng, nợ của nhân viên"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Tiền thưởng, nợ của nhân viên</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm nhân viên"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === +filter.userId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              userId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm thưởng/nợ</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"}</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            max={moment().format("YYYY-MM-DD")}

                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                            disabled={editId}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="date"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Nhân viên
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          {editId ? <>
                            <Controller
                              control={control}
                              name="userId"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  isDisabled={true}
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={userOptions}
                                  value={userOptions.find(
                                    (c) => c.value === value
                                  )}
                                  onChange={(val) => onChange(val.value)}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="userId"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </> : <>
                            <Controller
                              control={control}
                              name="userIds"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  isMulti
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={userOptions}
                                  value={userOptions.filter(
                                    (c) => value.includes?.(c.value)
                                  )}
                                  onChange={(val) => {
                                    onChange(val?.map(e => e.value) || [])
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="userIds"
                              render={({ message }) => (
                                <span className="invalid">{message}</span>
                              )}
                            />
                          </>}

                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Danh mục
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="category"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={EMPLOYEE_PAY_IN_OUT_CATEGORY_OPTIONS}
                                value={EMPLOYEE_PAY_IN_OUT_CATEGORY_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="category"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Số tiền(đ)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="amount"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="amount"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Nội dung
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="description"
                            render={({ onChange, value, ref }) => (
                              <Input value={value} innerRef={ref} onChange={(e) => onChange(e.target.value)} />

                            )}
                          />

                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <span>{editId ? "Sửa" : "Thêm"}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>


        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PayInOutManager;
